module.exports = __webpack_public_path__ + "static/img/ka_ka.c47842c.jpg";